import { EnumWidgetType, WidgetManyQuery } from "gql/generated";
import { WidgetKey } from "./WidgetAppView.config";
import { getMultilingualString } from "shared/utils";

const filterListsByArchivedStatus = (
  widgets: WidgetManyQuery["widgetMany"],
  archived: boolean,
) => {
  return widgets.filter((widget) => widget.archived === archived);
};

const filterWidgetsBySearchValue = (
  widgets: WidgetManyQuery["widgetMany"],
  searchValue: string,
) => {
  return widgets.filter((item) =>
    getMultilingualString(item.name)
      .toLowerCase()
      .includes(searchValue.toLowerCase()),
  );
};

const filterWidgetsByFavoriteStatus = (
  widgets: WidgetManyQuery["widgetMany"],
  favorited: boolean,
) =>
  widgets.filter(
    (widget) => widget.favorited === favorited && !widget.archived,
  );

export const getFilteredWidgets = (
  widgets: WidgetManyQuery["widgetMany"],
  key: string,
  searchValue?: string,
) => {
  let filteredWidgets = widgets;
  switch (key) {
    case WidgetKey.All:
      filteredWidgets = filterListsByArchivedStatus(widgets, false);
      break;
    case WidgetKey.Operator:
      filteredWidgets = filterListsByArchivedStatus(widgets, false).filter(
        (widget) => widget.type === EnumWidgetType.Operator,
      );
      break;
    case WidgetKey.Event:
      filteredWidgets = filterListsByArchivedStatus(widgets, false).filter(
        (widget) => widget.type === EnumWidgetType.Event,
      );
      break;
    case WidgetKey.Favorited:
      filteredWidgets = filterWidgetsByFavoriteStatus(widgets, true);
      break;
    case WidgetKey.Archived:
      filteredWidgets = filterListsByArchivedStatus(widgets, true);
      break;
    default:
      filteredWidgets = [];
  }
  if (searchValue) {
    filteredWidgets = filterWidgetsBySearchValue(filteredWidgets, searchValue);
  }
  return filteredWidgets;
};
